import React from 'react';
import { useTranslation } from "react-i18next";
import { getPlatform } from "@/hooks";

const OTCText = ({ sent_to }) => {
    const { t } = useTranslation('customer');

     return (
         <div
             className={`m2g-list-cell m2g-list-cell--text m2g-text
                ${getPlatform() === 'web' ? '--small' : ''}
             m2g-text--offset`}
             style={{padding: '1em'}}
         >
             {t('otc_explanation_text', { sent_to })}
         </div>
     )
}

export default OTCText;
